<template>
	<div class="z-z-scrollDiv"   @mouseenter="update" @mousemove="dragMove($event)" >
		<div class="z-scroll-main" ref="scroll">
			<slot></slot>
		</div>
		<div v-show="showBar" class="z-scroll-bar" :class="{drag:dragFlag}" @mouseup="endDrag" @mouseleave="endDrag" >
			<div @mousedown="startDrag($event)" :style="{height:`${barHeight}px`,transform:`translateY(${moveY}px)`}"></div>
		</div>
	</div>
</template>

<script>
    export default {
		props:{
			speed:{
				type:Number,
				default:50,
			},
		},
		data(){
			return {
				minHeight:20,  //px
				barHeight:0,   //px
				moveY:0,
				showBar:false,

				dragFlag:false,
				startMouseY:0,
			}
		},
		computed:{
			scrollSpeed(){ //每次滚轮的触发的移动距离
				return this.speed || 50;
			}, 
		},
		mounted(){
			this.update();
			this.bindScroll();
		},
		methods:{
			update(){  //更新滚动条高度 和 位置
				let wrap = this.$refs.scroll;
				if(!wrap){
					return;
				}
				let minPer = this.minHeight*100/wrap.clientHeight;
				let per = wrap.clientHeight*100/ wrap.scrollHeight;
				this.showBar = per<100;

				// 更新滚动条高度
				this.barHeight = (per<minPer)?this.minHeight:wrap.clientHeight*per/100;
				// 更新滚动条位置
				let rate = (wrap.scrollHeight - wrap.clientHeight)/(wrap.clientHeight - this.barHeight);
				this.moveY = wrap.scrollTop/rate;
			},
			scrollBottom(second,h){  //滚动距离  默认滚动到底部
				let timer;
				let wrap = this.$refs.scroll;
				
				let start = wrap.scrollTop;
				let tar = h==undefined?wrap.scrollHeight:parseFloat(h);  //目标位置

				let step = Math.round( (tar - start)*10/second );


				timer = setInterval(function(){
					if(start*step >= tar*step){
						clearInterval(timer);
						return;
					}

					start+=step;
					wrap.scrollTop = start;
				},10);
			},
			startDrag(e){
				e = e || window.event;
				this.dragFlag = true;
				this.startMouseY = e.clientY;
			},
			endDrag(){
				this.dragFlag = false;
			},
			dragMove(e){  //滚动条移动
				e = e || window.event;

				if(this.dragFlag){
					let wrap = this.$refs.scroll;
					let cha = e.clientY - this.startMouseY;
					this.startMouseY = e.clientY;

					let rate = (wrap.scrollHeight - wrap.clientHeight)/(wrap.clientHeight - this.barHeight);
					wrap.scrollTop += cha*rate;
					this.moveY = wrap.scrollTop/rate;
					this.move_end();
				}
			},
			bindScroll(){ //注册事件
				let wrap = this.$refs.scroll;
				let keyStr = (document.mozFullScreen !== undefined)?"DOMMouseScroll":"mousewheel";

				wrap.addEventListener(keyStr,(e)=>{
					this.scrollMove.call(this,wrap,this.eventFilter(e));
					e.stopPropagation();
				});
			},
			eventFilter(e){  //过滤事件对象
				if(e.type === "mousewheel"){
					e.direction = e.wheelDelta<0?1:-1;
				}else if(e.type === "DOMMouseScroll"){
					e.direction = e.detail>0?1:-1;
				}
				return e;
			},
			scrollMove(wrap,e){  //滚轮移动
				e = e || window.event;
				wrap.scrollTop += e.direction*this.speed;
				let rate = (wrap.scrollHeight - wrap.clientHeight)/(wrap.clientHeight - this.barHeight);
				this.moveY = wrap.scrollTop/rate;
				this.move_end();
			},
			move_end(){   //移动操作的 最后一步
				this.$emit("scroll")
			},

		}
    }
</script>

<style lang="less">
	@bar_color:#cbd5e5;
	@samll_w:4px;
	@big_w:6px;

	.z-z-scrollDiv{
		position: relative;
		// overflow-x: visible;

		.z-scroll-main{
			height: 100%;
			overflow-x: visible;
			overflow-y: hidden;
		}

		&:hover{
			>.z-scroll-bar{
				opacity: 1;
			}
		}

		.z-scroll-bar{
			opacity: 0;
			position: absolute;
			height: 100%;
			right: 3px;
			top:0;
			width:@samll_w;

			>div{
				position: absolute;
				right: 0;
				top:0;
				transition:0.1s;
				cursor:pointer;
				width:@samll_w;
				border-radius: @samll_w/2;
				background:@bar_color;
			}
			
			&:hover{
				width:@big_w;
				>div{
					border-radius: @big_w/2;
					width:@big_w;
				}
			}

			&.drag{
				width: 100%;
			}
			
		}
	}

	
</style>





// WEBPACK FOOTER //
// scrollDiv.vue?dc9f12e4